<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
      
        <!--  <b-breadcrumb :items="breadcrumbs"/>   -->
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong> Finance Report </strong>
          </div>
          <b-row class="">

            <div id="overlayloder" v-if="lodershow">
              <div class="loader_loder"></div>
            </div>
            <b-col md="12" class="my-1">
              <form>
                <b-row>
                  <b-col cols="4">
                    <b-form-group label="Date : "  :label-cols="2" >
                      <v-date-picker
                        mode="single"
                        input-class="dateInput"
                        :available-dates="{ start: null, end: new Date() }"
                        v-model="selectedDate"
                      >
                      </v-date-picker>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4" v-if="is_finance_superadmin==1">
                    <b-form-group label="Hub"  :label-cols="2" >
                      <b-form-select class="form-control input" v-model="destinationhubid">
                           <option :value="selected"  >--Select--</option>
                           <option v-for="hub in hublist"   v-bind:value="hub.pickuplocationmasterid">{{hub.pickuplocationname}}</option>
                      </b-form-select>          
                   </b-form-group> 
                  </b-col>
                  <b-col cols="4">
                    <b-button size="md" variant="primary" @click="displaydata(is_finance_superadmin,destinationhubid)"
                      >Search</b-button
                    >&nbsp;&nbsp;&nbsp;
                    <a :href="downloadcsv" download target="_blank" v-if="totalRows>0"><b-button
                      size="md"
                      variant="primary"
                      type="button"
                      @click="downloadCSV_load()"
                      >Download</b-button
                    ></a>
                  </b-col>
                </b-row>
              </form>
            </b-col>
          </b-row>
          <br>
          <b-col sm="12" v-if="showhubwise">
            <div class="table-responsive">
              <b-table  show-empty stacked="md" :items="[summaryObj]" :fields="fields2" :bordered="bordered" thead-class="Collected" :filter="filter" @filtered="onFiltered"
              :busy="isBusy" responsive class="table-responsive">

                <template slot="dateofsum" slot-scope="row">
                    {{formatedDate}}
                </template>
              </b-table>
            </div>
            <p><strong>Cash on hand {{summaryObj.sumofCurrentCash}}</strong></p>

          </b-col>

          <div style="overflow: auto;">
            <table class="table" v-if="showhubwise">
        
              <thead>
              <tr>
                <th colspan="20" style="background-color:#DDEBF7">{{formatedDate}}</th>
              </tr>
                <tr>
                  <th scope="col" rowspan="2" style="background-color:#DDEBF7">Deliveryboy</th>
                  <th scope="col"  colspan="3" style="background-color:#FFF2CC">Previous Pending</th>
                  <th scope="col"  colspan="4" style="background-color:#A9D08E">MIS Report</th>
                  <th scope="col"  colspan="3" style="background-color:#DDEBF7">Collectable Of Selected Date</th>
                  <th scope="col" rowspan="2" style="background-color:#DDEBF7">Pending Collectable Of Selected Date</th>
                  
                </tr>
                <tr>
                
                  <th scope="col" style="background-color:#FFF2CC">Cash</th>
                  <th scope="col" style="background-color:#FFF2CC">POS </th>
                  <th scope="col" style="background-color:#FFF2CC"> Total</th>

                  <th scope="col" style="background-color:#A9D08E">Cash</th>
                  <th scope="col" style="background-color:#A9D08E">POS </th>
                  <th scope="col" style="background-color:#A9D08E"> Total</th>
                  <th scope="col">Sub Total</th>

                  <th scope="col" style="background-color:#DDEBF7">Cash</th>
                  <th scope="col" style="background-color:#DDEBF7">POS </th>
                  <th scope="col" style="background-color:#DDEBF7"> Total</th>
                </tr>
              </thead>
              <tbody v-if="overAllFinalArray.length>0">
                <tr v-for="overalldata in overAllFinalArray" :key="overalldata">
                  <th scope="row">{{overalldata.deliveryagentfirstname}}</th>

                  <th scope="row" style="background-color:#FFF2CC">{{overalldata.previous_cash}}</th>
                  <th scope="row" style="background-color:#FFF2CC">{{overalldata.previous_pos}}</th>
                  <th scope="row" style="background-color:#FFF2CC">{{overalldata.previous_totalamount}}</th>

                  <th scope="row" style="background-color:#A9D08E">{{overalldata.mis_cash}}</th>
                  <th scope="row" style="background-color:#A9D08E">{{overalldata.mis_pos}}</th>
                  <th scope="row" style="background-color:#A9D08E">{{overalldata.mis_totalamount}}</th>
                  <th scope="row" >{{overalldata.mis_subtotal}}</th>

                  <th scope="row" style="background-color:#DDEBF7">{{overalldata.current_cash}}</th>
                  <th scope="row" style="background-color:#DDEBF7">{{overalldata.current_pos}}</th>
                  <th scope="row" style="background-color:#DDEBF7">{{overalldata.current_totalamount}}</th>

                  <th scope="row" style="color:#FF0000 !important">{{overalldata.todayspending}}</th>          

                </tr>

              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="12" class="text-center">
                  <b> No Record Found</b>
                  </td>
                </tr>
              </tbody>
          </table>
          </div>

        </b-card>
      </b-col> 
      
      </b-row>

  </div>
</template>




<script>
import CONSTANTS from "@/utils/constants";
import Filters from "@/utils/filters";
import Utils from "@/utils";
export default {
  data: function() {
    return {
      lodershow:false,
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        // perPage: 10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: "asc",
        filter: null,
        selectedDate: new Date(),
        data:{},
        formatedDate:'',
        summaryObj:{},
        overAllFinalArray:[],
        grandTotalObj:{},
        fields2:[
            { key: 'sumofCurrentCash', label: 'Cash',},
            { key: 'sumofCurrentPOS', label: 'POS',},
            { key: 'sumOfTotalCurrentCashPos', label: 'TOTAL',},
            { key: 'dateofsum', label: 'Date',},
        ],
        fields:[
          { key: 'deliveryagentfirstname', label: 'Deliveryboy',},
            { key: 'previous_cash', label: 'Previous Cash',},
            { key: 'previous_pos', label: 'Previous POS',},
            { key: 'previous_totalamount', label: 'Previous Total Amount',},
            { key: 'mis_cash', label: 'MIS Cash',},
            { key: 'mis_pos', label: 'MIS POS',},
            { key: 'mis_totalamount', label: 'MIS Total Amount',},
            // { key: 'mis_totalamount', label: 'MIS Total Amount',},
            { key: 'current_cash', label: 'Current Cash',},
            { key: 'current_pos', label: 'Current POS',},
            { key: 'current_totalamount', label: 'Current Total Amount',},
            { key: 'todayspending', label: 'Today Spending',},
        ],

        downloadcsv:'',
        destinationhubid:'',
        selected: '',
        hublist:[],
        is_finance_superadmin:'',
        showhubwise:false
        
    }
  },

    computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },


   created: function() {
        // this.displaydata();
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)

        this.is_finance_superadmin=userInfo.is_finance_superadmin;

        if(userInfo.is_finance_superadmin==1){
          this.getHublist();
        }
        else{
          this.displaydata(this.is_finance_superadmin);
        }
  },


    methods: {

      getHublist: function() {
        this.lodershow=true;
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        console.log("userInfo",userInfo)
        var currenthub=userInfo.pickuplocationmasterid;
        var hubobj={
          hub_id:currenthub.toString()
        }

          this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/gethublist`,hubobj)
          .then(result => {
            this.lodershow=false;
            if(result.body.returnmsg=='Successful'){
            this.hublist = result.body.returnvalue;
            }
            //console.log('mukesh',this.hublist);
          })
          .catch(ex => {
            console.log('error', ex)
          });
      },

      downloadCSV_load(){
        // alert("ok")
         var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      var fromdatenew =
        this.selectedDate != null ? this.formatDate(this.selectedDate) : "";

        var hub_id = userInfo.pickuplocationmasterid;
        var fromDate = fromdatenew;

        if(userInfo.is_finance_superadmin==1){
          this.downloadcsv = `${CONSTANTS.MISREPORT_API_URL}/getFinanceReportDataCSV?hub_id=`+this.destinationhubid+`&fromDate=`+fromDate
          console.log("downloadcsv",this.downloadcsv)
        }
        else{
          this.downloadcsv = `${CONSTANTS.MISREPORT_API_URL}/getFinanceReportDataCSV?hub_id=`+hub_id+`&fromDate=`+fromDate
          console.log("downloadcsv",this.downloadcsv)
        }
      },

    displaydata: function(isfinacevalue,value) {
      this.lodershow=true;
      console.log("value",value)
      console.log("++++",isfinacevalue)
      this.showhubwise=true;
      // document.getElementById("overlay").style.display = "block";
      this.isBusy = true;
      
      this.formatedDate = this.formatDate(this.selectedDate)
      //var fromdate = this.formatDate(this.selectedDate);

      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      //console.log(userInfo);
      const customerGetobj = {
        fromDate: this.formatDate(this.selectedDate),
        hub_id: `${isfinacevalue==1?value:userInfo.pickuplocationmasterid}`,

      };
      this.$http
        .post(
          `${CONSTANTS.MISREPORT_API_URL}/getFinanceReportData`,
          customerGetobj
        )
        .then((result) => {
          // document.getElementById("overlay").style.display = "none";
          this.lodershow=false;
          if (result.body) {
            
            this.isBusy = !this.isBusy;
            this.data = result.body;

            this.summaryObj = this.data.summaryObj
            this.overAllFinalArray = this.data.overAllFinalArray;
            this.grandTotalObj = this.data.grandTotalObj;
            this.totalRows = this.data.overAllFinalArray.length

            // console.log("overAllFinalArray",this.overAllFinalArray)

          } else {
            this.isBusy = !this.isBusy;
            this.items = result.body.returnvalue;
            // this.totalRows = result.body.returnvalue.length;
          }
        })
        .catch((ex) => {
          console.log("error-----", ex);
        });
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },


    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },

    formatDatenew: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("/");
    },


    }


}

</script>


<style type="text/css">
.totalback {
  background: #c8ced3 !important;
  border-right: 1px solid grey !important;
}

.Collected {
  text-align: center !important;
}
#overlayloder {
  position: fixed; /* Sit on top of the page content */
  /*display: none;  Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.loader_loder  {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left: 50%;
  top: 50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.bordered-value{

  padding:15px;
  border-bottom:1px solid #C8CED3;
  margin:-9px;
}

.hidden_header {
  display: none;
}

th{
  text-align:center;
}


</style>
